import styled from 'styled-components';

import Input from '@/components/Base/Input';
import Select from '@/components/Base/Select';
import {
  colorGrey200,
  mediaQueryMobileLargeMin,
  mediaQueryTabletMin,
} from '@/styleUtils';

export const InputStyles = styled(Input)`
  margin: -1px;
  border-radius: 4px 0 0 4px;
  box-shadow:
    inset 0 -1px 0 ${colorGrey200},
    inset 0 1px 0 ${colorGrey200},
    inset 1px 0 0 ${colorGrey200};
`;

export const SelectStyles = styled(Select)`
  max-width: 64px;
  margin: -1px;

  & > button {
    border-radius: 0 4px 4px 0;
    padding: 10px 12px;
  }
`;

export const AmountFilter = styled.div`
  display: flex;
  border: 1px solid ${colorGrey200};
  border-radius: 4px;
  width: 100%;

  @media ${mediaQueryMobileLargeMin} {
    max-width: 350px;
  }

  @media ${mediaQueryTabletMin} {
    max-width: 256px;
    width: 256px;
  }
`;
